import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=2ba079f7&scoped=true&"
import script from "./ProductGallery.vue?vue&type=script&lang=ts&"
export * from "./ProductGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=2ba079f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba079f7",
  null
  
)

export default component.exports